import React from 'react';
import PropTypes from 'prop-types';

const Whoami = props => (
  <h1>
    Haloo
    {props.user && props.user.username}
  </h1>
);
Whoami.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
};
export default Whoami;
